// Latest Commit
import React, { useEffect } from 'react';
import './App.css'
import { Header2 } from './components/NavBar/Header2'
import Home from './components/Home/Home';
import Footer from './components/Footer/Footer';
import About from './components/About/About';
import Countries from './components/Countries/Countries';
import Universe from './components/HomeUpdates/Universe';
import Team from './components/Team/Team';
import FAQ from './components/FAQ/FAQ';

const App = () => {
  useEffect(() => {
    document.title = "Sunrise Study"
  }, [])

  return (
    <>
      <Header2 />
      <Home />
      <About />
      <Team />
      <Countries />
      <Universe />
      <FAQ />
      <Footer />
    </>
  );
}

export default App;